import engravingToolModal from '@maison/store/engravingToolModal';
import eventsMenu from '@maison/store/eventsMenu';

export default {
  engravingToolModal,
  eventsMenu,
};
